import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'mc-code-editor-status-bar',
  templateUrl: './code-editor-status-bar.component.html',
  styleUrls: ['./code-editor-status-bar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CodeEditorStatusBarComponent {
  @Input() color: string;
  @Input() text: string;
}
